import React from 'react';

const PoliciesAndConditions = () => {
    return (
        <div>
            <div className="agreement-item">
                <h2>Writer’s liabilities</h2>
                <h3><b>The Writer is obliged to:</b></h3>

                <ul className="list">
                    <li>Register under your real name and provide valid contact details. Keep Team Leaders updated in case of any changes. Working under multiple or fake accounts (credentials) is strictly prohibited.</li>
                    <li>Not to publish, resell, or post on the Internet any original essays, written for the Company.</li>
                    <li>Keep all the information regarding orders and clients in complete confidentiality.</li>
                    <li>Follow all the Customer's instructions and guidelines when working on papers.</li>
                    <li>Follow the Company's standards and requirements for papers.</li>
                    <li>Upload the final version of the paper before the deadline set in the order.</li>
                    <li>Be ready to revise the completed papers within 30 days after completion according to the clients’ needs and requests without extra charges by the deadline as requested by the Team Leader/Customer.</li>
                </ul>
                <p><b>Systematic violation of the obligations stated in the clauses above could result in Termination of Cooperation</b></p>
            </div>

            <div className="agreement-item">
                <h2>Standard paper requirements</h2>
                <table>
                    <tbody>
                        <tr>
                            <td><b>No plagiarism</b></td>
                            <td>
                                <p>Our company has <b>zero tolerance</b> any cases of plagiarism such as:</p>
                                <ul className="list mb20">
                                    <li>Directly copied and not (improperly) referenced works of other authors;</li>
                                    <li>Paraphrased and not referenced ideas and thoughts of other authors;</li>
                                    <li>References to nonexistent sources or fake references to real sources;</li>
                                    <li>Anything directly copied from your own words submitted before.</li>
                                </ul>
                                <p>All papers are scanned for plagiarism on submission, as it may endanger academic record of the client.</p>
                            </td>
                        </tr>
                        <tr>
                            <td><b>Following client’s requirements</b></td>
                            <td>
                                Papers should <b>always address</b> all of the points specified in the order description.
                            </td>
                        </tr>
                        <tr>
                            <td><b>Correct number of words and format</b></td>
                            <td>
                                You must have <b>min 300 words per double-spaced page</b> (min 600 words per single-spaced page) and use 12 point Times New Roman font, left alignment of the text (no justification) and one-inch margins on all sides (2.54 cm).<br />
                                There are several <b>citation styles</b>: MLA, APA, Chicago, Harvard, etc.
                            </td>
                        </tr>
                        <tr>
                            <td><b>Scholarly sources</b></td>
                            <td>
                                Wikipedia or any similar online encyclopedias cannot be used as <b>a valid source</b>.
                            </td>
                        </tr>
                        <tr>
                            <td><b>Appropriate language, phrasing and content</b></td>
                            <td>
                                Your papers must be <b>free of grammar and spelling mistakes</b>. Please, proofread them carefully before submitting.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className="notice">
                    * Your papers will be randomly checked by our quality assurance department. Graders will provide comments and feedback on your works, as well as determine the final grade for the assignments (55-100). Grades for checked assignments determine your average grader score and, as a result, your writer group.
                </p>
            </div>

            <div className="agreement-item">
                <h2><b>Writer groups: bonuses and limitations</b></h2>
                <table>
                    <tbody>

                        <tr>
                            <td>Newbie</td>
                            <td>
                                <ul className="list">
                                    <li>Writers who completed less than <b>3 orders</b> regardless of their score.</li>
                                    <li>A <b>$5 bonus</b> is paid for completing each of the first 3 orders within the specified time.</li>
                                    <li>Orders in progress total cost limit: <b>$30</b>.</li>
                                </ul>
                            </td>
                        </tr>

                        <tr>
                            <td>Red</td>
                            <td>
                                <ul className="list">
                                    <li>Writers whose average grader score is <b>below 70</b>.</li>
                                    <li>No bonuses and limited access to available orders.</li>
                                </ul>
                            </td>
                        </tr>

                        <tr>
                            <td>Basic</td>
                            <td>
                                <ul className="list">
                                    <li>Writers whose average grader score is <b>between 70 and 79</b>.</li>
                                    <li>Orders in progress total cost limit: <b>$150</b></li>
                                </ul>
                            </td>
                        </tr>

                        <tr>
                            <td>Silver</td>
                            <td>
                                <ul className="list">
                                    <li>Writers whose average grader score is between <b>80 and 89</b>.</li>
                                    <li>Orders in progress total cost limit: <b>$250</b></li>
                                </ul>
                            </td>
                        </tr>

                        <tr>
                            <td>Gold</td>
                            <td>
                                <ul className="list">
                                    <li>Writers whose average grader score is <b>over 90</b>.</li>
                                    <li>Unlimited access to available orders.</li>
                                    <li>Writers from this group get a 10% bonus for every order they complete</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="agreement-item">
                <h3><b>Penalties and Fines</b></h3>
                <table>
                    <tbody>
                        <tr>
                            <th>Fines</th>
                            <th>Violations</th>
                        </tr>
                        <tr>
                            <td><b>50% - 100%</b> of the order value</td>
                            <td>For receiving D or F grades on completed orders</td>
                        </tr>
                        <tr>
                            <td>up to <b>100 %</b> of the order value</td>
                            <td>
                                <ul className="list">
                                    <li>Accepting the order for which another writer was specified as a preferred one</li>
                                    <li>Low quality of the paper (serious issues related to language, phrasing or content)</li>
                                    <li>Failure to follow the instructions</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>up to <b>100 %</b> of the order value</td>
                            <td>
                                <ul className="list">
                                    <li>Missed deadlines for submitting the paper</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>up to <b>100 %</b> of the order value</td>
                            <td>
                                <ul className="list">
                                    <li>Failure/refusal to submit the final paper</li>
                                    <li>Failure/refusal to revise the paper</li>
                                    <li>Accepting 2 identical orders and submitting similar papers</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className="notice mb20">* &nbsp;We reserve the right to terminate cooperation with our writers at any time without a prior notice for violation of our policies.</p>
            </div>

            <div className="agreement-item">
                <h3><b>Payments</b></h3>
                <ul className="list">
                    <li>
                        The earned sum for the completed orders will be available for withdrawal in 14 days after the writer’s deadline for the order.
                    </li>
                    <li>
                        You can withdraw funds from your available balance twice a month (by the 10th and the 25th day).
                    </li>
                    <li>
                        The salary will be paid out within the 10 days after the withdrawal request deadline. If you request a withdrawal more than once during one payment period, your last withdrawal request will be processed.
                    </li>
                    <li>
                        Our system allows you to indicate multiple (up to 3) withdrawal methods at a time: Payoneer, Skrill, and Pay Pal. We expect you to have at least 2 verified payment method in your writer account at all times.
                    </li>
                    <li>
                        All the payment details you mention will have to be verified by our finance department (might take up to 12 hours). We may have to postpone the payment till the next payment period if any of the requested details are not specified, are specified incorrectly or are not verified.
                    </li>
                </ul>
                <table>
                    <tbody>
                        <tr>
                            <th>Payment methods</th>
                            <th>Required information</th>
                            <th>Comments</th>
                        </tr>
                        <tr>
                            <td>Payoneer</td>
                            <td>Payee ID</td>
                            <td>Our preferred payment method, guide on how to set up an account is provided</td>
                        </tr>
                        <tr>
                            <td>Skrill</td>
                            <td>E-mail used to log into your Skrill account</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Pay Pal</td>
                            <td>E-mail used to log into your PayPal account</td>
                            <td>This option is not available for Ukrainian writers</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="agreement-item">

                <h2><b>Termination of Cooperation</b></h2>
                <p className="mb20"><b>The Company reserves a right to terminate cooperation and annual writer’s account (by notifying the Writer via email or phone) in the following cases:</b></p>

                <ul className="list">
                    <li>Disclosure of information considering orders, selling/donating/sharing papers with any third parties.</li>
                    <li>Using several user names or fake credentials.</li>
                    <li>Systematic violation of  Writer's liabilities.</li>
                </ul>

                <p className="mb20"><b>The Writer reserves a right to terminate cooperation at any time if he/she doesn't have any pending orders by notifying Team Leaders via email or phone.</b></p>

                <p className="mb20">
                    <b>The Company reserves a right to terminate writer’s account that has been inactive for over 60 days.</b>
                    Inactivity means that the Writer did not login to their personal control panel for more than 1 month and/or did not complete any orders during a two-month period. The account may be re-opened upon Writer's request and Company's discretion. All earnings pending will be paid to the Writer within the nearest payment period if requested.
                </p>

                <p><b>The Company reserves a right to terminate writer’s account that has been in the red group for 2 months.</b></p>
            </div>
        </div>
    );
};

export default PoliciesAndConditions;


// WEBPACK FOOTER //
// ./src/components/agreement/PoliciesAndConditions.js